import React, { useState } from 'react';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';
import { fmtDate } from '../../lib/dates';

const TAG = { hipotesis: 'bg-amber-500/15 text-amber-300', validada: 'bg-emerald-500/15 text-emerald-300', rechazada: 'bg-rose-500/15 text-rose-300' };

// AI hypothesis with its verbatim official quotes; only a lawyer's validation turns it into knowledge Fidem may use
export const Hypothesis = ({ aid, h, byId, onChange }) => {
  const { api } = useAuth();
  const [note, setNote] = useState('');
  const decide = async (decision) => {
    try { await api.put(`/court-trends/${aid}/hypotheses/${h.id}`, { decision, note }); toast.success(decision === 'validada' ? 'Validada: Fidem podrá usarla citando la muestra' : 'Rechazada'); onChange(); } catch (e) { toast.error(e?.response?.data?.detail || 'No se pudo guardar'); }
  };
  return (
    <div data-testid={`hyp-${h.id}`} className="rounded-xl border border-slate-800 p-3 text-xs">
      <div className="flex flex-wrap items-center gap-2"><span className={`rounded-full px-2 py-0.5 ${TAG[h.estado]}`}>{h.estado}</span><span className="text-slate-500">{h.tipo} · {h.sentencias.length} sentencias · {h.metodo}</span></div>
      <p className="mt-1 text-sm text-slate-200">{h.criterio}</p>
      {h.citas.map((c) => <p key={c.id + c.texto.slice(0, 20)} className="mt-1 text-slate-400">«{c.texto}» — <a href={byId[c.id]?.url} target="_blank" rel="noreferrer" className="text-sky-300 underline">Rol {byId[c.id]?.rol}</a></p>)}
      {!!h.contrarias.length && <p className="mt-1 text-rose-300/80">Decisiones contrarias: {h.contrarias.map((x) => `Rol ${byId[x]?.rol}`).join(', ')}</p>}
      {h.estado === 'hipotesis' ? (
        <div className="mt-2 flex flex-wrap gap-2">
          <input data-testid={`hyp-note-${h.id}`} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Nota de revisión" className="min-w-0 flex-1 rounded border border-slate-700 bg-slate-950 px-2 py-1" />
          <button data-testid={`hyp-validate-${h.id}`} onClick={() => decide('validada')} className="rounded bg-emerald-600 px-3 py-1 text-white">Validar</button>
          <button data-testid={`hyp-reject-${h.id}`} onClick={() => decide('rechazada')} className="rounded bg-rose-600 px-3 py-1 text-white">Rechazar</button>
        </div>
      ) : <p className="mt-1 text-slate-500">Revisado por {h.revisado_por} · {fmtDate(h.revisado_at, true)}{h.nota ? ` · ${h.nota}` : ''}</p>}
    </div>
  );
};
